import classNames from 'classnames'
import styles from './index.module.scss'

type SingleSelectDropdownProps = {
  className?: string
  options: SelectItem[]
  onSelectItem: (option: SelectItem) => void
}

const SingleSelectDropdown: React.FC<SingleSelectDropdownProps> = ({
  options,
  onSelectItem,
  className,
}) => (
  <div
    className={classNames(
      'position-absolute bg-white zindex-dropdown px-3 py-4',
      styles.filter_new_dropdown_container,
      className
    )}
  >
    {options.map((option) => (
      <div
        key={option.value}
        onClick={() => onSelectItem(option)}
        className={classNames('text-date-dark', styles.filter_dropdown_option)}
      >
        {option.label}
      </div>
    ))}
  </div>
)

export default SingleSelectDropdown
